import React from 'react';

import {UfSelection} from 'presentation/pages/private/uf-selection';
import {LocationSelectionFlowEnum} from 'presentation/utils';

export const MakeUfSelection: React.FC<{
	flowType: LocationSelectionFlowEnum;
}> = ({flowType}) => <UfSelection flowType={flowType} />;
